import {ProductImageCarousel} from "./modules/ProductCarousels";
import SimpleLightbox from "simplelightbox";

ProductImageCarousel();

const galleryLightbox = () => {
    new SimpleLightbox('.woocommerce-product-gallery__wrapper a', {
        showCounter: false,
        history: false,
        captions: false,
        captionSelector: self
    });
}

galleryLightbox();

